import styled from 'styled-components'

export const TextSliderContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const TextSliderCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  > * {
    margin: 0;
  }

  > header {
    color: #a39999;
  }

  > h2 {
    color: #303032;
    font-size: 32px;
    line-height: 48px;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 48px;
    }
  }

  > p {
    color: #303032;
  }
`

export const TextSliderActionsContainer = styled.footer`
  display: flex;
  align-items: center;
  gap: 2rem;
  width: max-content;
  margin-left: -0.25rem;
  margin-top: auto;
`

export const SliderButton = styled.button<{
  $color: string
  $icColor?: string
}>`
  width: 40px;
  height: 40px;
  background-color: transparent;
  padding: 0;

  outline: 0;
  border: 0;

  > figure {
    width: 100%;
    height: 100%;
  }

  &:focus,
  &:hover {
    outline: 0;
  }

  > figure:hover,
  > figure:focus {
    outline: 0;
  }
`

export const LeftSliderButton = styled(SliderButton)`
  &:hover {
    > figure {
      outline: 0;
      > svg > path:first-child {
        fill: #abbed1;
      }
    }
  }

  ${({ $icColor }) =>
    $icColor &&
    `
      > figure {
        > svg > path:nth-child(2) {
          fill: ${$icColor};
        }
      }
    `}
`

export const RightSliderButton = styled(SliderButton)`
  &:hover {
    > figure {
      outline: 0;
      > svg > path:nth-child(2) {
        fill: #abbed1;
      }
    }
  }

  ${({ $icColor }) =>
    $icColor &&
    `
    figure {
      > svg > path:nth-child(3) {
        fill: ${$icColor};
      }
    }
  `}
`
